export function proverka() {
  var f = "fix";
  var d = "dev";
  var x = "ice";
  var p = ".pro";
  if (window.location.hostname !== f + d + x + p && window.location.hostname !== "localhost" && window.location.hostname !== "fxde.ru") {
    malert.show({
      title: "\u042D\u0442\u043E \u043A\u043E\u043F\u0438\u044F \u043D\u0430\u0448\u0435\u0433\u043E \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430 https://".concat(f + d + x + p),
      text: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0432\u0438\u0434\u0438\u0442\u0435 \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0437\u043D\u0430\u0447\u0438\u0442 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u043A \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043B \u043D\u0430\u0448 \u0441\u0430\u0439\u0442 \u0438 \u0432\u044B\u0434\u0430\u0451\u0442 \u0435\u0433\u043E \u0437\u0430 \u0441\u0432\u043E\u0439",
      btmPrevent: true
    });
    if ($(".malert-prevent ")) $(".malert-prevent ").addEventListener("click", function (e) {
      window.location.href = "https://" + f + d + x + p;
    });
  }
}